import React from "react";

import { IReasonExperience } from "../../../state";
import { formatDate } from "../../../libs/Util";

import styles from "./AssessmentComment.module.scss";

export type Props = {
  reasons: IReasonExperience[];
};

const AssessmentComment: React.FC<Props> = ({ reasons }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.listComment}>
        {reasons.map((item, index) => (
          <div key={index} className={styles.commentDetail}>
            <p>{item.reason}</p>
            <span>{formatDate(item.created_at, ".")}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssessmentComment;
